<template>
	<ProcessCreatePage>
		<Header :title="title" />
		<div class="main" v-if="lawyerOffice?.id === null">
			<div>
				<div class="flex flex-wrap">
					<BaseInput ref="BaseInput.lawyerOffice.name" :required="true" class="w-full" label="Name" type="text" v-model="lawyerOffice.name" />
				</div>

				<AddressInput v-model="lawyerOffice" />

				<div class="flex flex-wrap">
					<BaseInput
						ref="BaseInput.lawyerOffice.phoneNumber"
						:required="true"
						class="w-full md:w-1/2 pr-0 md:pr-2"
						:label="$t('phone')"
						v-model="lawyerOffice.phoneNumber"
						type="tel"
						validationtype="phone"
					/>

					<BaseInput
						:required="true"
						ref="BaseInput.lawyerOffice.email"
						validationtype="email"
						class="w-full md:w-1/2 pl-0 md:pl-2"
						:label="$t('e_mail')"
						v-model="lawyerOffice.email"
						:error-message="$t('e_mail_not_valid')"
						type="email"
					/>
				</div>
			</div>
		</div>

		<Footer
			@backButtonClick="$emit('previous', $event)"
			@continueButtonClick="continueButtonClick"
			@skipButtonClick="continueButtonClick(true)"
			:is-skippable="!isUserAllowedInLevel5or6 && !(lawyerOffice && lawyerOffice.name)"
		/>
	</ProcessCreatePage>
</template>

<script>
import Footer from '@/components/damagecases/Footer';
import Header from '@/components/damagecases/Header';
import Authentication from '@/mixins/Authentication';
import AddressInput from '@/components/forms/AddressInput';
import BaseInput from '@/components/forms/inputs/BaseInput';
import Validate from '@/mixins/Validate';
import ProcessCreatePage from '@/views/management/Process/ProcessCreatePage';

export default {
	name: 'ForeignLawyerOffice',
	components: { ProcessCreatePage, BaseInput, AddressInput, Header, Footer },
	mixins: [Authentication, Validate],
	props: {
		title: {
			default: function() {
				return this.$t('new_damage_case_lawyers_office');
			},
		},
		lawyerOffice: { id: null, city: {
      }, },
	},
	methods: {
		continueButtonClick(isSkip) {
			if (isSkip) {
				this.$emit('next', null);
			} else if (this.validate()) {
				this.$emit('next', { lawyerOffice: this.lawyerOffice });
			} else {
				this.$swal(this.$t('general.attention').toString(), this.$t('please_check_input').toString(), 'warning');
			}
		},
	},
};
</script>

<style scoped></style>
